// extracted by mini-css-extract-plugin
export var form = "_ck-0";